import { LoadingScreen } from '@/components/ui/LoadingScreen';
import { ROUTES } from '@/consts/routes';
import { useAuthStore } from '@/stores/useAuthStore';
import { Navigate } from 'react-router';

interface AuthGuardProps {
  children: React.ReactNode;
}

export const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { isLoaded, isSignedIn, isLoadingUserData } = useAuthStore();

  if (!isLoaded) {
    return <LoadingScreen message="loading.session" />;
  }

  if (!isSignedIn) {
    return <Navigate to={ROUTES.auth.login} replace />;
  }

  if (isLoadingUserData) {
    return <LoadingScreen message="loading.userData" />;
  }

  return <>{children}</>;
};
